import { TYPE_ICON_COLOR } from '../../utils/notificationHelpers';
import TrashIcon from './TrashIcon';

const NotificationListRow = ({
  item,
  isActive,
  selectMode,
  isChecked,
  onToggleCheck,
  onSelect,
  onDelete,
}) => (
  <div
    className={`border-b border-gray-100 ${isActive ? 'bg-blue-50' : 'bg-white'} hover:bg-gray-50/80`}
  >
    <div className="flex items-start gap-3 px-4 py-4">
      {selectMode && (
        <input
          type="checkbox"
          checked={isChecked}
          disabled={item.isSystem}
          onChange={() => onToggleCheck(item.id)}
          className="mt-1 h-4 w-4 rounded border-gray-300 text-brand-medium-blue focus:ring-brand-medium-blue disabled:opacity-40"
          aria-label={`Select ${item.title}`}
        />
      )}
      <button type="button" onClick={() => onSelect(item)} className="min-w-0 flex-1 text-left">
        <div className="flex items-start gap-3">
          <div
            className={`mt-1 h-2.5 w-2.5 flex-shrink-0 rounded-full ${
              TYPE_ICON_COLOR[item.type] || TYPE_ICON_COLOR.general
            }`}
          />
          <div className="min-w-0 flex-1">
            <div className="flex items-start justify-between gap-2">
              <p className="text-sm font-semibold text-gray-900">{item.title}</p>
              <span className="whitespace-nowrap text-xs text-gray-400">{item.relativeTime}</span>
            </div>
            <p className="mt-1 line-clamp-1 text-sm text-gray-600">{item.preview}</p>
          </div>
          {!item.isRead && (
            <span className="mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-red-500" />
          )}
        </div>
      </button>
      {!item.isSystem && (
        <button
          type="button"
          onClick={() => onDelete(item)}
          className="mt-0.5 rounded p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600"
          aria-label={`Delete ${item.title}`}
        >
          <TrashIcon />
        </button>
      )}
    </div>
  </div>
);

export default NotificationListRow;
